<template>
  <sweet-modal blocking :title="$t('project_tab_meetings_first_card_shiftMeeting')" ref="lateMeetingModal" class="modal" v-on:close="closeModal">
    <el-form :rules="rules" :model="form" status-icon ref="form" class="form" size="mini">
      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item prop="startDate">
            <el-date-picker
                format="d MMM yy"
                v-model="form.startDate"
                type="date"
                value-format="ddMMyyyy"
                :placeholder="$t('modal_startDate')"
                :picker-options="pickerOptions"
                style="width: 100%;"
                @change="setStartDate">
            </el-date-picker>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item prop="startTime">
            <el-time-select
                v-model="form.startTime"
                :picker-options="{
                                  minTime: countMinTimeStartMeeting(form.startDate),
                                  start: '00:00',
                                  step: '00:15',
                                  end: '24:00'
                                  }"
                :placeholder="$t('modal_startTime')"
                @change="setStartTime"
                style="width: 100%;">
            </el-time-select>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row v-if="false">
        <el-checkbox v-model="form.setReminder" @change="selectReminder">{{$t('modal_meeting_setReminder')}}</el-checkbox>
      </el-row>
      <el-row v-if="form.setReminder">
        <el-form-item prop="reminderTime" class="reminder-time-block">
          <el-date-picker
              :disabled="!form.startDate && !form.startTime"
              v-model="form.reminderTime"
              :picker-options="reminderTimePickerOptions"
              ref="reminderTimePicker"
              value-format="ddMMyyyyHH:mm"
              @change="selectTimePickerReminder"
              type="datetime">
          </el-date-picker>
        </el-form-item>
      </el-row>
        <el-form-item :label="$t('project_tab_meetings_first_card_reason')" prop="reason" class="reason-block">
          <el-input
              type="textarea"
              :rows="2"
              placeholder="Please input"
              v-model="form.reason">
          </el-input>
        </el-form-item>
      <el-form-item class="modal__btn">
        <el-button @click="save('form')" type="primary">{{$t('general_submit')}}</el-button>
      </el-form-item>
    </el-form>
  </sweet-modal>
</template>

<script>
import moment from "moment";
import { SweetModal } from '@totalflow4/tfsweet-modal-vue';
import axios from "axios";

export default {
name: "LateMeetingModal",
  components:{
    SweetModal,
  },
  props: {
    meetingType: {
      type: Number,
      default: 1
    },
    page: {
      type: Number,
      default: 1
    }
  },
  data(){
    return {
      meeting: null,
      state: null,
      form: {
        startDate: '',
        startTime: '',
        setReminder: false,
        reminderTime: null,
        reason: null,
      },
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() < Number(moment().subtract(1, 'days').format('x'));
        },
      },
      reminderTimePickerOptions: {
        selectableRange: '00:00:00-23:59:59',
        disabledDate: this.disabledReminderTimePicker
      },
      rules: {
        startDate: [{
          required: true,
          message: this.$i18n.t('modal_settings_fieldIsRequired'),
          trigger: 'change'
        }],
        startTime: [{
          required: true,
          message: this.$i18n.t('modal_settings_fieldIsRequired'),
          trigger: 'change'
        }],
        reminderTime: [{
          required: true,
          message: this.$i18n.t('modal_settings_fieldIsRequired'),
          trigger: 'change'
        }],
        reason: [{
          required: true,
          message: this.$i18n.t('modal_settings_fieldIsRequired'),
          trigger: 'change'
        }]
      }
    }
  },
  methods:{
    openModal(meeting, state){
      console.log('meeting', meeting)
      this.meeting = meeting
      this.state = state
      this.$refs.lateMeetingModal.open()
    },
    save(form){
      this.$refs[form].validate((valid) => {
        if (valid) {
          let time = moment(this.form.startTime, 'hh:mm').format('HHmm');
          let startTimestamp = moment(this.form.startDate + time, 'DDMMYYYYHHmm').format('X');
          let url = `/api/v1/meetings/later`;
          // switch (this.state) {
          //   case 'projectMeetings':
          //     url = `/api/v1/projectMeetings/later`
          //     break;
          //   case 'businessUnitMeetings':
          //     url = `/api/v1/businessUnitMeetings/later`
          //     break;
          //   case 'engagementMeetings':
          //     url = `/api/v1/engagementMeetings/later`
          //     break;
          //   case 'projectTaskMeetings':
          //     url = `/api/v1/projectTaskMeetings/later`
          //     break;
          //   case 'businessUnitTaskMeetings':
          //     url = `/api/v1/businessUnitTaskMeetings/later`
          //     break;
          //   case 'engagementTaskMeetings':
          //     url = `/api/v1/engagementTaskMeetings/later`
          //     break;
          // }
          const data = {
            typeId: this.meetingType,
            companyId: this.$route.query.companyId,
            parentId: this.meeting.parentId,
            taskId: this.meeting.taskId ? this.meeting.taskId : null,
            startTimestamp: startTimestamp,
            meetingId: this.meeting.id,
            reminderTime: this.form.reminderTime,
            setReminder: this.form.setReminder,
            reason: this.form.reason
          }
          let loader = this.$loading.show();
          axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
          axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
          axios
              .post(url, data)
              .then(response => {
                this.$store.dispatch('getMeetings', {
                  companyId: this.$route.query.companyId,
                  parentId: this.meeting.parentId,
                  taskId: this.meeting.taskId || null,
                  typeId: this.meetingType,
                  page: this.page
                })
                loader.hide()
                // switch (this.state) {
                //   case 'projectMeetings':
                //     this.$store.dispatch('getProjectMeetings')
                //    break;
                //   case 'businessUnitMeetings':
                //     this.$store.dispatch('getBusinessUnitMeetings')
                //     break;
                //   case 'engagementMeetings':
                //     this.$store.dispatch('getEngagementMeetings')
                //     break;
                //   case 'projectTaskMeetings':
                //     this.$store.dispatch('getProjectTaskMeetings', { taskId: this.meeting.projectTaskId} )
                //     break;
                //   case 'businessUnitTaskMeetings':
                //     this.$store.dispatch('getBusinessUnitTaskMeetings', this.meeting.businessUnitTaskId)
                //     break;
                //   case 'engagementTaskMeetings':
                //     this.$store.dispatch('getEngagementTaskMeetings', this.meeting.engagementTaskId)
                //     break;
                // }
                this.notification(this.$t('general_success'), this.$t('notification_updateMeeting'), "success");
                this.$refs.lateMeetingModal.close()
              })
              .catch(error => {
                console.log('An error occurred:', error);
                loader.hide()
              })
        }
      })
    },
    setStartDate(date) {
      const currentDate = moment().format('DDMMYYYY')

      if (date === currentDate && this.form.startTime) {
        const currentTime = moment().format('HH:mm')
        if (Number(moment(this.form.startTime, 'HH:mm').format('x')) <=
            Number(moment(currentTime, 'HH:mm').format('x'))) {
          this.form.startTime = ''
        }
      }
      // handle reminder time
      this.setReminderTimeTimeRange(date, this.form.startTime)
      // reset reminder
      this.form.reminderTime = null
    },
    selectReminder(val){
      if (!val) this.form.reminderTime = null;
    },
    setReminderTimeTimeRange(date, time) {
      if (date && time) {
        const currentDate = moment().format('DDMMYYYY')
        const currentTime = moment().format('HH:mm:00')
        const times = this.reminderTimePickerOptions.selectableRange.split('-')
        // handle current date and currentDate
        if (date === currentDate) {
          times[0] = moment(currentTime, 'HH:mm:ss').add(15, 'minutes').format('HH:mm:00')
          times[1] = moment(time, 'HH:mm:ss').subtract(15, "minutes").format('HH:mm:00')
        } else {
          // handle selected date in calendar
          times[0] = '00:00:00'
          times[1] = '23:59:59'
        }
        this.reminderTimePickerOptions.selectableRange = times.join('-')
      }
      console.log('this.reminderTimePickerOptions.selectableRange', this.reminderTimePickerOptions.selectableRange)
    },
    selectTimePickerReminder(val) {
      console.log('selectTimePickerReminder', val)
    },
    countMinTimeStartMeeting(selectedDate){
      const currentDate = moment().format('DDMMYYYY')
      const currentTime = moment().format('HH:mm')
      if (selectedDate === currentDate) {
        // const currentTime = moment().format('HH:mm')
        // console.log('currentTime', currentTime)

        // get last 2 chars from current time
        const lastTwoNums = parseInt(currentTime.slice(-2));
        switch (true) {
          case (lastTwoNums < 15):
            return currentTime.slice(0, -1).replace(/.$/,"15")
          case (lastTwoNums < 30):
            return currentTime.slice(0, -1).replace(/.$/,"30")
          case (lastTwoNums < 45):
            return currentTime.slice(0, -1).replace(/.$/,"45")
          default:
            return moment(currentTime, 'HH:mm').add(1, 'hours').format('HH:mm').slice(0, -1).replace(/.$/,"00")
        }
      } else {
        return false
      }
    },
    setStartTime(val){
      this.setReminderTimeTimeRange(this.form.startDate, val)
      // reset reminder
      this.form.reminderTime = null
    },
    disabledReminderTimePicker(time){
      const start = time.getTime() < Date.now() - 8.64e7;
      let end = false
      if (this.form.startDate) {
        end = time.getTime() > Number(moment(this.form.startDate, 'DDMMYYYY').format('x'))
      }
      if (start){
        return start
      }else if(end){
        return end
      }
    },
    closeModal(){
      this.meeting = null;
      this.state = null;
      this.form.startDate = '';
      this.form.startTime = '';
      this.form.reminderTime = null;
      this.form.reason = null;
      this.$refs['form'].resetFields();
    },
    notification(title, message, type) {
      this.$notify({
        title: title,
        message: message,
        type: type
      });
    }
  },
  watch: {
    'form.reminderTime': function (val) {
      const currentDate = moment().format('DDMMYYYY')
      const currentTime = moment().format('HH:mm:00')
      const times = this.reminderTimePickerOptions.selectableRange.split('-')
      // handle if user set reminder not today and in meeting day
      if (this.form.startDate === moment(val, 'DDMMYYYYHH:mm').format('DDMMYYYY') && currentDate !== this.form.startDate) {
        times[0] = '00:00:00'
        times[1] = moment(this.form.startTime, 'HH:mm').subtract(15, "minutes").format('HH:mm:00')
        // handle if user set reminder today and in meeting day
      } else if (this.form.startDate === moment(val, 'DDMMYYYYHH:mm').format('DDMMYYYY') && currentDate === this.form.startDate) {
        times[0] = moment(currentTime, 'HH:mm:ss').add(15, 'minutes').format('HH:mm:00')
        times[1] = moment(this.form.startTime, 'HH:mm').subtract(15, "minutes").format('HH:mm:00')
        // handle not today and in another day
      } else {
        times[0] = '00:00:00'
        times[1] = '23:59:59'
      }
      this.reminderTimePickerOptions.selectableRange = times.join('-')
    }
  }
}
</script>

<style scoped>

</style>
